/* global Splide, GLightbox */
(function () {
        function isGift(section) {
            return section.classList.contains('gift')
        }

        const productGalleryEl = document.querySelector('.product-gallery[data-product-id]');
        const section = productGalleryEl.closest && productGalleryEl.closest('section');
        const productId = productGalleryEl ? String(productGalleryEl.dataset.productId) : null;
        if (!productId || productId === '9871427109192') {
            return;
        }

        function destroyGallery(mainElState) {
            if (!mainElState) return;
            try {
                if (mainElState.mainInst) mainElState.mainInst.destroy(true);
                if (mainElState.thumbsInst) mainElState.thumbsInst.destroy(true);
            } catch (e) {
                console.warn('destroy main error', e);
            }

            try {
                if (mainElState.glightbox) {
                    mainElState.glightbox.destroy();
                }
            } catch (e) { /* noop */ }
        }

        const galleryState = new WeakMap();

        function initGallery(mainEl, thumbEl) {
            if (!mainEl) {
                return;
            }
            const mainList = mainEl.querySelector('.splide__list');
            const slidesCount = mainList ? mainList.querySelectorAll('.splide__slide').length : 0;
            if (!mainList || slidesCount === 0) {
                return;
            }

            if (galleryState.has(mainEl)) {
                const old = galleryState.get(mainEl);
                try {
                    if (old.mainInst) old.mainInst.destroy(true);
                    if (old.thumbsInst) old.thumbsInst.destroy(true);
                    destroyGallery(old);
                } catch (e) { /* noop */ }
                galleryState.delete(mainEl);
            }

            let thumbsInstance = null;
            let mainInstance = null;
            if (thumbEl) {
                const thumbList = thumbEl.querySelector('.splide__list');
                const thumbSlidesCount = thumbList ? thumbList.querySelectorAll('.splide__slide').length : 0;
                if (thumbSlidesCount > 0) {
                    try {
                        thumbsInstance = new Splide(thumbEl, {
                            perPage: 6,
                            gap: 4,
                            drag: false,
                            pagination: false,
                            isNavigation: true,
                            arrows: false,
                            focus: 'center',
                            breakpoints: {640: {perPage: 3}, 900: {perPage: 5}}
                        });
                        thumbsInstance.mount();
                    } catch (e) {
                        thumbsInstance = null;
                    }
                }
            }
            const mobilePerPage = slidesCount === 1 ? 1 : 1.05;
            try {
                mainInstance = new Splide(mainEl, {
                    type: 'slide',
                    perPage: 1,
                    focus: 'center',
                    pagination: false,
                    drag: true,
                    keyboard: false,
                    arrows: false,
                    lazyLoad: 'nearby',
                    gap: '1rem',
                    breakpoints: {
                        768: {
                            perPage: mobilePerPage,
                            perMove: 1,
                            gap: '4px',
                            focus: 'left',
                            drag: true,
                            flickMaxPages: 1,
                            flickPower: 100,
                            rewindByDrag: false,
                            rewind: false,
                        }
                    }
                });
            } catch (e) {
                return;
            }

            try {
                mainInstance.on('mounted', function () {
                    try {
                        playActiveVideoInMain(0);
                    } catch (e) { /* noop */ }
                });
                mainInstance.on('move', function (newIndex) {
                    try {
                        playActiveVideoInMain(newIndex);
                    } catch (e) { /* noop */ }
                });
            } catch (e) { /* noop */ }

            try {
                if (thumbsInstance) mainInstance.sync(thumbsInstance);
                mainInstance.mount();
                mainEl.dataset.splideInitialized = 'true';
            } catch (e) {
                console.error('mount failed', e);
            }

            function playActiveVideoInMain(index) {
                const slides = Array.from(mainEl.querySelectorAll('.splide__slide'));
                slides.forEach((slide, idx) => {
                    const vid = slide.querySelector('video.product-gallery-video');
                    if (!vid) return;
                    try {
                        if (!vid.src || !vid.getAttribute('src')) {
                            const ds = vid.getAttribute('data-src') || (vid.dataset && (vid.dataset.src || vid.dataset.videoSrc || vid.dataset.video));
                            if (ds) {
                                vid.src = ds;
                                try {
                                    vid.load();
                                } catch (e) { /* noop */ }
                            }
                        }
                        if (idx === index) {
                            try {
                                vid.muted = true;
                            } catch (e) { /* noop */ }
                            try {
                                vid.setAttribute && vid.setAttribute('playsinline', '');
                            } catch (e) { /* noop */ }
                            const p = vid.play && vid.play();
                            if (p && p.catch) p.catch(() => {
                            });
                        } else {
                            try {
                                vid.pause();
                            } catch (e) { /* noop */ }
                        }
                    } catch (e) { /* noop */ }
                });
            }

            if (!window._pw_single_video_play_guard) {
                window._pw_single_video_play_guard = true;
                document.addEventListener('play', function (ev) {
                    const p = ev.target;
                    if (!p || p.tagName && p.tagName.toLowerCase() !== 'video') return;
                }, true);
            }

            const state = {
                mainEl,
                mainInst: mainInstance,
                thumbsInst: thumbsInstance,
                glightbox: null,
                _glightboxSyncHandler: null
            };
            galleryState.set(mainEl, state);
            try {
                const lb = initLightboxForMain(mainEl);
                if (lb) {
                    state.glightbox = lb;
                }
            } catch (e) {
                console.warn('initLightboxForMain error', e);
            }
            if (thumbEl) {
                const clickHandler = (ev) => {
                    const slide = ev.target && ev.target.closest ? ev.target.closest('.splide__slide') : null;
                    if (!slide || !thumbEl.contains(slide)) return;
                    ev.preventDefault();

                    const slides = Array.from(thumbEl.querySelectorAll('.splide__slide'));
                    const idx = slides.indexOf(slide);
                    if (idx === -1) return;

                    try {
                        if (mainInstance && typeof mainInstance.go === 'function') mainInstance.go(idx);
                    } catch (e) { /* noop */ }
                };
                thumbEl.addEventListener('click', clickHandler);
            }
        }


        function initLightboxForMain(mainEl) {
            if (!mainEl) return null;
            const slides = Array.prototype.slice.call(mainEl.querySelectorAll('.splide__slide'));
            if (!slides.length) return null;

            const BASE = 'https://myflowers.co.uk/';

            function normalizeUrl(href) {
                if (!href || typeof href !== 'string') return '';
                href = href.trim();
                if (/^https?:\/\//i.test(href)) return href;
                if (/^\/\//.test(href)) return 'https:' + href;
                if (/^\//.test(href)) return BASE.replace(/\/$/, '') + href;
                return BASE + href.replace(/^\/+/, '');
            }

            const items = slides.map(function (slide) {
                const mediaType = (slide.getAttribute('data-media-type') || '').toLowerCase();
                const poster = normalizeUrl(slide.getAttribute('poster'));

                if (mediaType === 'video') {
                    let src = slide.getAttribute('src') || (slide.querySelector('video') && slide.querySelector('video').dataset && slide.querySelector('video').dataset.src) || '';
                    let posterLocal = slide.getAttribute('poster');
                    if (src) {
                        const safeSrc = String(src).replace(/"/g, '&quot;');
                        return {
                            href: safeSrc, type: 'video',
                            source: 'local'
                        };
                    }
                    return {href: posterLocal, type: 'image'};
                }

                const imgEl = slide.querySelector('img');
                const href = normalizeUrl((imgEl && (imgEl.getAttribute('data-large') || imgEl.src)) || '');
                return {href: href || (poster || ''), type: 'image'};
            });
            let filtered = items.filter(i => (i.href && i.href.trim()) || i.html);

            if (!filtered.length) return null;

            let lightbox = null;
            try {
                lightbox = GLightbox({
                    elements: filtered,
                    loop: false,
                    touchNavigation: true,
                    keyboardNavigation: true,
                    autoplayVideos: true,
                    plyr: {
                        config: {
                            ratio: '1:1',
                            muted: true,
                            loop: {active: true},
                            keyboard: {
                                focused: false,
                                global: false
                            }
                        },
                    }
                });
            } catch (e) {
                lightbox = null;
            }

            const _syncHandler = function ({_, current} = {}) {
                try {
                    if (!current) return;
                    const idx = (typeof current.slideIndex === 'number') ? current.slideIndex : null;
                    if (typeof idx !== 'number') return;
                    const state = galleryState.get(mainEl);
                    if (!state) return;
                    try {
                        if (state.mainInst) state.mainInst.go(idx);
                        if (state.thumbsInst) state.thumbsInst.go(idx);
                    } catch (e) { /* noop */ }
                } catch (e) { /* noop */ }
            };

            slides.forEach(function (slide, idx) {
                slide.addEventListener('click', function () {
                    try {
                        if (lightbox) lightbox.openAt(idx);
                    } catch (err) {
                        console.warn('lightbox open failed', err);
                    }
                });
            });

            try {
                lightbox.on('slide_changed', _syncHandler);
                const state = galleryState.get(mainEl);
                if (state) {
                    state.glightbox = lightbox;
                    state._glightboxSyncHandler = _syncHandler;
                }
            } catch (e) {
                console.warn('lightbox sync attach failed', e);
            }

            return lightbox;
        }

        function autoInitAll() {
            const containers = Array.from(document.querySelectorAll('.product-gallery'));
            containers.forEach(container => {
                const main = container.querySelector('[id^="main-slider-"], .splide.splide--main, .splide');
                if (!main) return;
                const thumb = container.querySelector('[id^="thumb-slider-"], .splide.thumbs, .splide--thumbs');
                initGallery(main, thumb || null);
            });
        }

    document.addEventListener('DOMContentLoaded', function () {
        try {
            autoInitAll();
        } catch (e) {
            console.error('autoInitAll failed', e);
        }
    });
})();

(function () {
        const selectorVariant = '[data-variant-selection]';
        const productGalleryEl = document.querySelector('.product-gallery[data-product-id]');
        const productId = productGalleryEl ? String(productGalleryEl.dataset.productId) : null;
        const mainRoot = document.querySelector('.splide:not(.splide--thumbs)');
        const thumbsRoot = document.querySelector('.splide--thumbs');
        const tpl = document.querySelector('#slider-variants');
        const variantEl = document.querySelector(selectorVariant);

        if (!productId || productId !== '9871427109192' || !variantEl || !tpl || !mainRoot) {
            return;
        }

        let splideMain = null;
        let splideThumbs = null;
        let glightboxMain = null;
        let _glightboxSyncHandler = null;


        function getMainListFromTemplate(variantId) {
            return tpl.content.querySelector(`ul#main-photo[data-variant-id="${variantId}"]`);
        }

        function getThumbsListFromTemplate(variantId) {
            return tpl.content.querySelector(`ul#thumbnails-photo[data-variant-id="${variantId}"]`);
        }

        function stopAndCleanupVideos(container) {
            if (!container) return;
            container.querySelectorAll('video').forEach(v => {
                try {
                    v.pause();
                } catch (e) { /* noop */ }
                if (v.hasAttribute('src')) {
                    v.removeAttribute('src');
                    try {
                        v.load();
                    } catch (e) { /* noop */ }
                }
            });
        }

        function playActiveVideoInMain(index) {
            const slides = Array.from(mainRoot.querySelectorAll('.splide__slide'));
            slides.forEach((slide, idx) => {
                const vid = slide.querySelector('video.product-gallery-video');
                if (!vid) return;
                try {
                    if (!vid.src || !vid.getAttribute('src')) {
                        const ds = vid.getAttribute('data-src') || (vid.dataset && (vid.dataset.src || vid.dataset.videoSrc || vid.dataset.video));
                        if (ds) {
                            vid.src = ds;
                            try {
                                vid.load();
                            } catch (e) { /* noop */ }
                        }
                    }
                    if (idx === index) {
                        try {
                            vid.muted = true;
                        } catch (e) { /* noop */ }
                        try {
                            vid.setAttribute && vid.setAttribute('playsinline', '');
                        } catch (e) { /* noop */ }
                        const p = vid.play && vid.play();
                        if (p && p.catch) p.catch(() => {
                        });
                    } else {
                        try {
                            vid.pause();
                        } catch (e) { /* noop */ }
                    }
                } catch (e) { /* noop */ }
            });
        }

        function loadVideos(container) {
            if (!container) return;
            container.querySelectorAll('video[data-src]').forEach(video => {
                if (!video.src) {
                    video.src = video.getAttribute('data-src');
                    try {
                        video.load();
                    } catch (e) { /* noop */ }
                }
            });
        }

        function replaceListInRoot(root, newList) {
            const targetSplide = (typeof splideMain !== 'undefined' && root === mainRoot) ? splideMain :
                (typeof splideThumbs !== 'undefined' && root === thumbsRoot) ? splideThumbs :
                    null;

            function getSplideLength(s) {
                if (!s) return 0;
                if (typeof s.length === 'number') return s.length;
                try {
                    return (s.Components && s.Components.Elements && s.Components.Elements.slides)
                        ? s.Components.Elements.slides.length
                        : (s.root ? s.root.querySelectorAll('.splide__slide').length : 0);
                } catch (e) {
                    return 0;
                }
            }


            try {
                const rootEl = targetSplide.root || root;
                if (rootEl) {
                    const h = rootEl.getBoundingClientRect().height;
                    if (h) rootEl.style.minHeight = `${h}px`;
                    rootEl.style.pointerEvents = 'none';
                }

                let len = getSplideLength(targetSplide);
                for (let i = len - 1; i >= 0; i--) {
                    try {
                        targetSplide.remove(i);
                    } catch (e) { /* ignore */
                    }
                }

                const children = Array.from(newList.children || []);
                const htmlSlides = children.map(ch => (ch && ch.outerHTML) ? ch.outerHTML : String(ch));

                htmlSlides.forEach(html => {
                    try {
                        targetSplide.add(html);
                    } catch (e) { /* ignore */
                    }
                });

                try {
                    if (targetSplide === splideMain && splideThumbs) {
                        if (typeof splideMain.sync === 'function') splideMain.sync(splideThumbs);
                    } else if (targetSplide === splideThumbs && splideMain) {
                        if (typeof splideMain.sync === 'function') splideMain.sync(splideThumbs);
                    }
                } catch (e) { /* noop */ }

            } catch (err) {
                console.warn('replaceListInRoot via Splide API failed, fallback to DOM replace', err);
            }
        }

        function initThumbsSplide() {
            if (!thumbsRoot || typeof Splide === 'undefined') return;
            splideThumbs = new Splide(thumbsRoot, {
                perPage: 6,
                gap: 4,
                drag: false,
                pagination: false,
                isNavigation: true,
                arrows: false,
                focus: 'center',
            });
            splideThumbs.mount();
        }

        function initMainSplide(startIndex = 0) {
            if (typeof Splide === 'undefined') {
                return;
            }
            splideMain = new Splide(mainRoot, {
                type: 'slide',
                perPage: 1,
                focus: 'center',
                pagination: false,
                drag: true,
                keyboard: false,
                arrows: false,
                lazyLoad: 'nearby',
                gap: '1rem',
                breakpoints: {
                    768: {
                        perPage: 1.05,
                        perMove: 1,
                        gap: '4px',
                        focus: 'left',
                        drag: true,
                        flickMaxPages: 1,
                        flickPower: 100,
                        rewindByDrag: false,
                        rewind: false,
                    }
                }
            });
            try {
                splideMain.on('mounted', function () {
                    try {
                        playActiveVideoInMain(startIndex);
                    } catch (e) { /* noop */ }
                });
                splideMain.on('move', function (newIndex) {
                    try {
                        playActiveVideoInMain(newIndex);
                    } catch (e) { /* noop */ }
                });
            } catch (e) { /* noop */ }
            splideMain.mount();
        }

        function syncSliders() {
            if (splideMain && splideThumbs && typeof splideMain.sync === 'function') {
                splideMain.sync(splideThumbs);
            }
        }

        const BASE = 'https://myflowers.co.uk/';

        function normalizeUrl(href) {
            if (!href || typeof href !== 'string') return '';
            href = href.trim();
            if (/^https?:\/\//i.test(href)) return href;
            if (/^\/\//.test(href)) return 'https:' + href;
            if (/^\//.test(href)) return BASE.replace(/\/$/, '') + href;
            return BASE + href.replace(/^\/+/, '');
        }

        function destroyGlightbox() {
            try {
                if (glightboxMain && typeof glightboxMain.destroy === 'function') {
                    glightboxMain.destroy();
                }
            } catch (e) { /* noop */ }
            try {
                if (_glightboxSyncHandler) {
                    try {
                        if (glightboxMain) {
                            glightboxMain.off('slide_changed', _glightboxSyncHandler);
                        }
                        document.removeEventListener('glightbox_slide_changed', _glightboxSyncHandler);
                    } catch (e) { /* noop */ }
                    _glightboxSyncHandler = null;
                }
            } catch (e) { /* noop */ }
            glightboxMain = null;
        }

        function initGlightboxForMain(mainEl) {
            destroyGlightbox();
            if (!mainEl) return null;

            const slides = Array.prototype.slice.call(mainEl.querySelectorAll('.splide__slide'));
            if (!slides.length) return null;
            const items = slides.map(function (slide) {
                const mediaType = (slide.getAttribute('data-media-type') || '').toLowerCase();
                const vidEl = slide.querySelector('video');

                if (mediaType === 'video' || vidEl) {
                    let src = vidEl.getAttribute('src');
                    const poster = normalizeUrl(slide.getAttribute('poster'));

                    if (src) {
                        const safeSrc = String(src).replace(/"/g, '&quot;');
                        return {href: safeSrc, type: 'video', source: 'local'};
                    }
                    return {href: poster, type: 'image'};
                }
                const imgEl = slide.querySelector('img');
                const href = normalizeUrl((imgEl && (imgEl.getAttribute('data-large') || imgEl.src)) || '');
                return {href: href || '', type: 'image'};
            });

            let filtered = items.filter(i => (i.href && i.href.trim()) || i.html);

            if (!filtered.length) return null;
            try {
                glightboxMain = GLightbox({
                    elements: filtered,
                    loop: false,
                    touchNavigation: true,
                    keyboardNavigation: true,
                    autoplayVideos: true,
                    plyr: {
                        config: {
                            ratio: '1:1',
                            muted: true,
                            loop: {active: true},
                            keyboard: {
                                focused: false,
                                global: false
                            }
                        },
                    }
                });
            } catch (e) {
                console.warn('GLightbox init failed', e);
                glightboxMain = null;
            }
            _glightboxSyncHandler = function ({_, current} = {}) {
                try {
                    if (!current) return;
                    const idx = (typeof current.slideIndex === 'number') ? current.slideIndex : null;
                    if (typeof idx === 'number') {
                        splideMain.go(idx);
                        splideThumbs.go(idx);
                    }
                } catch (e) { /* noop */ }
            };

            try {
                glightboxMain.on('slide_changed', _glightboxSyncHandler);
            } catch (e) { /* noop */ }

            slides.forEach(function (slide, idx) {
                slide.addEventListener('click', function () {
                    try {
                        if (glightboxMain) glightboxMain.openAt(idx);
                    } catch (err) { /* noop */ }
                });
            });
            return glightboxMain;
        }

        function switchSliderToVariant(variantId) {
            const v = String(variantId);
            const mainTplList = getMainListFromTemplate(v);
            if (!mainTplList) return;

            const currentIndex = (splideMain) ? splideMain.index : 0;

            stopAndCleanupVideos(mainRoot.querySelector('.splide__list'));

            const newMainList = mainTplList.cloneNode(true);
            loadVideos(newMainList);

            let newThumbsList = null;
            if (thumbsRoot) {
                const thumbsTplList = getThumbsListFromTemplate(v);
                if (thumbsTplList) {
                    newThumbsList = thumbsTplList.cloneNode(true);
                }
            }

            replaceListInRoot(mainRoot, newMainList);
            if (thumbsRoot && newThumbsList) {
                replaceListInRoot(thumbsRoot, newThumbsList);
            }
            try {
                if (splideThumbs && typeof splideThumbs.refresh === 'function') {
                    splideThumbs.refresh();
                }
            } catch (e) { /* noop */ }

            try {
                if (splideMain && typeof splideMain.refresh === 'function') {
                    splideMain.refresh();
                }
            } catch (e) { /* noop */ }
            syncSliders();
            initGlightboxForMain(mainRoot);
            playActiveVideoInMain(currentIndex);
        }

        function onVariantChange(variantId) {
            if (!variantId) return;
            switchSliderToVariant(variantId);
        }

        let last = variantEl.getAttribute('variant');
        // The server renders the selected variant's media on first load; real variant
        // changes afterwards are handled by the MutationObserver below.

        const mo = new MutationObserver(() => {
            const v = variantEl.getAttribute('variant');
            if (v !== last) {
                last = v;
                onVariantChange(v);
            }
        });
        mo.observe(variantEl, {attributes: true, attributeFilter: ['variant']});
        try {
            initThumbsSplide();
        } catch (e) { /* noop */ }
        try {
            initMainSplide(0);
        } catch (e) { /* noop */ }
        syncSliders();
        initGlightboxForMain(mainRoot);
})();